import React, { useEffect, memo, createElement } from 'react';
import ReactPixel from 'meta-pixel';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { CTAButton } from './CTAButton';
import { CheckCircle2, XCircle, Lock, ShieldCheck, ChevronRight } from 'lucide-react';
const PURCHASE_LINK = 'https://pagos.fegion.online/cart/45866696441995:1';
export function SalesPage() {
  useEffect(() => {
    // Initialize Meta Pixel directly via script injection
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '904978025482552');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-amber-200" data-id="element-7">
      <CountdownTimer data-id="element-8" />
      <SocialProofPopup data-id="element-9" />

      {/* SECTION 2 - HERO */}
      <section className="pt-12 pb-16 px-4 max-w-5xl mx-auto text-center" data-id="element-10">
        <div className="inline-block bg-purple-100 border border-purple-200 rounded-full px-6 py-2 mb-8" data-id="element-11">
          <p className="text-purple-800 font-semibold text-sm md:text-base" data-id="element-12">
            🟣 Para contadores que quieren dejar de operar en modo urgencia y
            construir un sistema que les devuelva control, previsibilidad y
            tranquilidad profesional.
          </p>
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-gray-900 tracking-tight mb-4 uppercase text-center" data-id="element-13">
          <span className="block" data-id="element-14">🏆 MEGA PACK</span>
          <span className="block text-amber-500" data-id="element-15">CONTADOR ÉLITE</span>
        </h1>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-600 mb-8" data-id="element-16">
          Sistema Integral de Organización y Control Profesional
        </h2>

        <a href="#compra" className="block cursor-pointer hover:opacity-95 transition-opacity mb-10" data-id="element-17">
          <img src="https://cdn.magicpatterns.com/uploads/5svdM9Vr3fm7mDu9g1j9fG/ChatGPT_Image_2_mar_2026,_23_46_16.png" alt="Mega Pack Contador Élite" className="w-full max-w-3xl mx-auto rounded-xl shadow-2xl" data-id="element-18" />
        </a>

        <div className="max-w-3xl mx-auto text-lg md:text-xl text-gray-700 space-y-4 mb-10 font-medium" data-id="element-19">
          <p data-id="element-20">Si tu estudio depende demasiado de vos…</p>
          <p data-id="element-21">Si los vencimientos te persiguen…</p>
          <p data-id="element-22">Si el mes se convierte en una carrera constante…</p>
          <p className="font-bold text-red-600 text-xl md:text-2xl mt-6" data-id="element-23">
            Trabajar más horas no va a solucionarlo.
          </p>
          <p className="mt-4" data-id="element-24">
            <span style={{
            color: '#F59E0B'
          }} className="font-bold" data-id="element-25">
              MEGA PACK CONTADOR ÉLITE
            </span>{' '}
            es un sistema estructurado diseñado para contadores que necesitan
            orden real, control operativo y tranquilidad profesional.
          </p>
        </div>

        <CTAButton text="👉 SÍ, QUIERO TRABAJAR CON ESTRUCTURA AHORA" data-id="element-26" />

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mt-6 font-semibold text-gray-700" data-id="element-27">
          <span className="flex items-center gap-2" data-id="element-28">
            <CheckCircle2 className="text-green-500 w-5 h-5" data-id="element-29" /> Acceso inmediato
          </span>
          <span className="flex items-center gap-2" data-id="element-30">
            <CheckCircle2 className="text-green-500 w-5 h-5" data-id="element-31" /> Implementación
            en 30 días
          </span>
          <span className="flex items-center gap-2" data-id="element-32">
            <CheckCircle2 className="text-green-500 w-5 h-5" data-id="element-33" /> Sistema
            replicable
          </span>
        </div>
      </section>

      {/* SECTION 3 - PAIN POINTS */}
      <section className="bg-gray-50 py-16 px-4 border-y border-gray-200" data-id="element-34">
        <div className="max-w-4xl mx-auto" data-id="element-35">
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-36">
            Déjame hacerte una pregunta honesta…
          </h3>

          <div className="space-y-6 text-lg md:text-xl font-medium bg-white p-8 rounded-2xl shadow-lg border border-gray-100" data-id="element-37">
            <p className="flex items-start gap-3" data-id="element-38">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-39" />{' '}
              ¿Sentís que si vos no controlás todo, el estudio se desordena?
            </p>
            <p className="flex items-start gap-3" data-id="element-40">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-41" />{' '}
              ¿Tenés que recordar vencimientos de memoria?
            </p>
            <p className="flex items-start gap-3" data-id="element-42">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-43" />{' '}
              ¿Perdés horas redactando correos e informes?
            </p>
            <p className="flex items-start gap-3" data-id="element-44">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-45" />{' '}
              ¿Los clientes preguntan lo mismo una y otra vez?
            </p>
            <p className="flex items-start gap-3" data-id="element-46">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-47" />{' '}
              ¿Terminás el día agotado, pero sin sensación de control?
            </p>
          </div>

          <div className="mt-12 text-center text-xl md:text-2xl font-bold space-y-2" data-id="element-48">
            <p data-id="element-49">No es falta de capacidad.</p>
            <p data-id="element-50">No es falta de experiencia.</p>
            <p className="text-amber-600 text-3xl mt-4" data-id="element-51">Es falta de sistema.</p>
            <p className="text-gray-600 mt-2" data-id="element-52">
              Y sin sistema… todo depende de vos.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4 - THE PROBLEM */}
      <section className="bg-black text-white py-20 px-4" data-id="element-53">
        <div className="max-w-4xl mx-auto text-center" data-id="element-54">
          <h2 className="text-4xl md:text-5xl font-black mb-12 text-amber-500" data-id="element-55">
            El problema que casi nadie reconoce
          </h2>

          <p className="text-xl md:text-2xl mb-8" data-id="element-56">
            Muchos contadores viven en modo reacción:
          </p>

          <ul className="text-lg md:text-xl space-y-4 text-left max-w-2xl mx-auto bg-gray-900 p-8 rounded-xl border border-gray-800" data-id="element-57">
            <li className="flex items-center gap-3" data-id="element-58">
              <div className="w-2 h-2 bg-amber-500 rounded-full" data-id="element-59"></div> Corren
              detrás de vencimientos
            </li>
            <li className="flex items-center gap-3" data-id="element-60">
              <div className="w-2 h-2 bg-amber-500 rounded-full" data-id="element-61"></div>{' '}
              Responden urgencias todo el día
            </li>
            <li className="flex items-center gap-3" data-id="element-62">
              <div className="w-2 h-2 bg-amber-500 rounded-full" data-id="element-63"></div> Trabajan
              más horas para compensar desorden
            </li>
            <li className="flex items-center gap-3" data-id="element-64">
              <div className="w-2 h-2 bg-amber-500 rounded-full" data-id="element-65"></div> Redactan
              desde cero cada comunicación
            </li>
            <li className="flex items-center gap-3" data-id="element-66">
              <div className="w-2 h-2 bg-amber-500 rounded-full" data-id="element-67"></div> No
              tienen estructura replicable
            </li>
          </ul>

          <div className="mt-12 text-2xl font-bold" data-id="element-68">
            <p className="mb-4" data-id="element-69">Lo peor no es el trabajo.</p>
            <p className="text-gray-400" data-id="element-70">Es la sensación constante de:</p>
            <blockquote className="text-3xl md:text-4xl text-amber-400 italic mt-6 font-black" data-id="element-71">
              "Cuando termine este mes me organizo..."
            </blockquote>
            <p className="text-gray-400 mt-6" data-id="element-72">
              Y el siguiente mes vuelve a empezar igual.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 5 - THE SOLUTION */}
      <section className="py-20 px-4 bg-white" data-id="element-73">
        <div className="max-w-5xl mx-auto text-center" data-id="element-74">
          <div className="inline-block bg-green-100 text-green-800 font-bold px-6 py-2 rounded-full text-xl mb-6" data-id="element-75">
            ✅ LA SOLUCIÓN
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-4 text-center" data-id="element-76">
            <span className="block" data-id="element-77">🏆 MEGA PACK</span>
            <span className="block text-amber-500" data-id="element-78">CONTADOR ÉLITE</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 mb-12" data-id="element-79">
            Un sistema integral diseñado para transformar la forma en que
            operás.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 mb-12" data-id="element-80">
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 w-full md:w-1/4" data-id="element-81">
              <span className="text-4xl block mb-2" data-id="element-82">📂</span>
              <p className="font-bold" data-id="element-83">Accedés al sistema</p>
            </div>
            <ChevronRight className="hidden md:block text-gray-400 w-8 h-8" data-id="element-84" />
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 w-full md:w-1/4" data-id="element-85">
              <span className="text-4xl block mb-2" data-id="element-86">📘</span>
              <p className="font-bold" data-id="element-87">Implementás por Tomos</p>
            </div>
            <ChevronRight className="hidden md:block text-gray-400 w-8 h-8" data-id="element-88" />
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 w-full md:w-1/4" data-id="element-89">
              <span className="text-4xl block mb-2" data-id="element-90">⚙</span>
              <p className="font-bold" data-id="element-91">Aplicás la estructura durante 30 días</p>
            </div>
            <ChevronRight className="hidden md:block text-gray-400 w-8 h-8" data-id="element-92" />
            <div className="bg-amber-50 p-6 rounded-xl border border-amber-200 w-full md:w-1/4 shadow-md" data-id="element-93">
              <span className="text-4xl block mb-2" data-id="element-94">🏆</span>
              <p className="font-bold text-amber-800" data-id="element-95">
                Convertís el orden en estándar profesional
              </p>
            </div>
          </div>

          <div className="text-2xl font-bold text-gray-800 space-y-2" data-id="element-96">
            <p data-id="element-97">
              Sin improvisación. Sin depender de memoria. Sin apagar incendios.
            </p>
            <p className="text-3xl text-amber-600 mt-4" data-id="element-98">
              Solo estructura clara.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 6 - WHAT'S INCLUDED */}
      <section className="py-16 px-4 bg-gray-50 border-t border-gray-200" data-id="element-99">
        <div className="max-w-6xl mx-auto" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-6" data-id="element-101">
            📘 ¿Qué incluye exactamente el
            <span className="block text-4xl md:text-5xl mt-2" data-id="element-102">
              🏆 MEGA PACK
            </span>
            <span className="block text-4xl md:text-5xl text-amber-500" data-id="element-103">
              CONTADOR ÉLITE
            </span>
          </h2>
          <p className="text-xl text-center text-gray-600 mb-12 font-medium" data-id="element-104">
            Un sistema dividido en 5 Tomos estratégicos + 3 Bonos Profesionales,
            organizados para implementación real.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-105">
            {/* Tomo 1 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-amber-500" data-id="element-106">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-107">
                📘 TOMO 1
              </h3>
              <h4 className="text-xl font-bold text-amber-600 mb-4" data-id="element-108">
                Fundamentos Contables
              </h4>
              <p className="text-gray-600 italic mb-4" data-id="element-109">
                La base para dejar de improvisar.
              </p>
              <ul className="space-y-2 font-medium" data-id="element-110">
                <li className="flex items-start gap-2" data-id="element-111">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-112"></div>{' '}
                  Orden estructural del estudio
                </li>
                <li className="flex items-start gap-2" data-id="element-113">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-114"></div>{' '}
                  Mentalidad profesional moderna
                </li>
                <li className="flex items-start gap-2" data-id="element-115">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-116"></div>{' '}
                  Organización operativa sin estrés
                </li>
                <li className="flex items-start gap-2" data-id="element-117">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-118"></div>{' '}
                  Sistema base de control
                </li>
              </ul>
            </div>

            {/* Tomo 2 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-amber-500" data-id="element-119">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-120">
                📘 TOMO 2
              </h3>
              <h4 className="text-xl font-bold text-amber-600 mb-4" data-id="element-121">
                Comunicación y Automatización
              </h4>
              <p className="text-gray-600 italic mb-4" data-id="element-122">
                Menos tiempo escribiendo. Más autoridad profesional.
              </p>
              <ul className="space-y-2 font-medium" data-id="element-123">
                <li className="flex items-start gap-2" data-id="element-124">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-125"></div>{' '}
                  Plantillas de correos estratégicos
                </li>
                <li className="flex items-start gap-2" data-id="element-126">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-127"></div>{' '}
                  Respuestas estructuradas para clientes
                </li>
                <li className="flex items-start gap-2" data-id="element-128">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-129"></div>{' '}
                  Sistema de comunicación mensual
                </li>
                <li className="flex items-start gap-2" data-id="element-130">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-131"></div>{' '}
                  Redacción profesional optimizada
                </li>
              </ul>
            </div>

            {/* Tomo 3 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-amber-500" data-id="element-132">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-133">
                📘 TOMO 3
              </h3>
              <h4 className="text-xl font-bold text-amber-600 mb-4" data-id="element-134">
                Análisis y Decisión en Minutos
              </h4>
              <p className="text-gray-600 italic mb-4" data-id="element-135">
                Transformá datos en claridad.
              </p>
              <ul className="space-y-2 font-medium" data-id="element-136">
                <li className="flex items-start gap-2" data-id="element-137">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-138"></div>{' '}
                  Resúmenes ejecutivos rápidos
                </li>
                <li className="flex items-start gap-2" data-id="element-139">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-140"></div>{' '}
                  Interpretación simplificada
                </li>
                <li className="flex items-start gap-2" data-id="element-141">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-142"></div>{' '}
                  Identificación de riesgos
                </li>
                <li className="flex items-start gap-2" data-id="element-143">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-144"></div>{' '}
                  Comparativos prácticos
                </li>
              </ul>
            </div>

            {/* Tomo 4 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-amber-500 lg:col-start-2" data-id="element-145">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-146">
                📘 TOMO 4
              </h3>
              <h4 className="text-xl font-bold text-amber-600 mb-4" data-id="element-147">
                Informes Profesionales de Alto Nivel
              </h4>
              <p className="text-gray-600 italic mb-4" data-id="element-148">
                Elevá la percepción de tu trabajo.
              </p>
              <ul className="space-y-2 font-medium" data-id="element-149">
                <li className="flex items-start gap-2" data-id="element-150">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-151"></div>{' '}
                  Estructura moderna de informes
                </li>
                <li className="flex items-start gap-2" data-id="element-152">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-153"></div>{' '}
                  Conclusiones estratégicas
                </li>
                <li className="flex items-start gap-2" data-id="element-154">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-155"></div>{' '}
                  Presentación clara
                </li>
                <li className="flex items-start gap-2" data-id="element-156">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-157"></div>{' '}
                  Profesionalización del lenguaje
                </li>
              </ul>
            </div>

            {/* Tomo 5 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-amber-500 lg:col-start-3" data-id="element-158">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-159">
                📘 TOMO 5
              </h3>
              <h4 className="text-xl font-bold text-amber-600 mb-4" data-id="element-160">
                Sistema ÉLITE de Implementación – 30 DÍAS
              </h4>
              <p className="text-gray-600 italic mb-4" data-id="element-161">
                Convertí todo en hábito operativo.
              </p>
              <ul className="space-y-2 font-medium" data-id="element-162">
                <li className="flex items-start gap-2" data-id="element-163">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-164"></div>{' '}
                  Plan estructurado paso a paso
                </li>
                <li className="flex items-start gap-2" data-id="element-165">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-166"></div>{' '}
                  Organización mensual replicable
                </li>
                <li className="flex items-start gap-2" data-id="element-167">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-168"></div>{' '}
                  Rutina semanal profesional
                </li>
                <li className="flex items-start gap-2" data-id="element-169">
                  <div className="mt-1.5 w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-170"></div>{' '}
                  Control sin improvisación
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 - BEFORE VS AFTER */}
      <section className="py-20 px-4 bg-white" data-id="element-171">
        <div className="max-w-5xl mx-auto" data-id="element-172">
          <h2 className="text-4xl md:text-5xl font-black text-center mb-12" data-id="element-173">
            Antes vs Después
          </h2>

          <div className="flex flex-col md:flex-row gap-8 mb-12" data-id="element-174">
            <div className="flex-1 bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-175">
              <h3 className="text-2xl font-bold text-red-800 mb-6 text-center border-b border-red-200 pb-4" data-id="element-176">
                Antes del Mega Pack
              </h3>
              <ul className="space-y-4 text-lg font-medium text-red-900" data-id="element-177">
                <li className="flex items-start gap-3" data-id="element-178">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-179" />{' '}
                  Vivís bajo presión constante
                </li>
                <li className="flex items-start gap-3" data-id="element-180">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-181" />{' '}
                  Todo depende de tu memoria
                </li>
                <li className="flex items-start gap-3" data-id="element-182">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-183" />{' '}
                  Trabajás más horas para compensar desorden
                </li>
                <li className="flex items-start gap-3" data-id="element-184">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-185" />{' '}
                  Redactás desde cero
                </li>
                <li className="flex items-start gap-3" data-id="element-186">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-187" />{' '}
                  Sentís que el estudio te controla a vos
                </li>
              </ul>
            </div>

            <div className="flex-1 bg-green-50 p-8 rounded-2xl border border-green-200 shadow-xl transform md:-translate-y-4" data-id="element-188">
              <h3 className="text-2xl font-bold text-green-800 mb-6 text-center border-b border-green-200 pb-4" data-id="element-189">
                Después de implementar el sistema
              </h3>
              <ul className="space-y-4 text-lg font-medium text-green-900" data-id="element-190">
                <li className="flex items-start gap-3" data-id="element-191">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-192" />{' '}
                  Operás con estructura clara
                </li>
                <li className="flex items-start gap-3" data-id="element-193">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-194" />{' '}
                  Tenés control mensual visible
                </li>
                <li className="flex items-start gap-3" data-id="element-195">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-196" />{' '}
                  Reducís urgencias
                </li>
                <li className="flex items-start gap-3" data-id="element-197">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-198" />{' '}
                  Respondés con plantillas profesionales
                </li>
                <li className="flex items-start gap-3" data-id="element-199">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-200" />{' '}
                  Recuperás tiempo real
                </li>
                <li className="flex items-start gap-3" data-id="element-201">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-202" />{' '}
                  Sentís dominio operativo
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center mb-12" data-id="element-203">
            <p className="text-2xl font-bold text-gray-600" data-id="element-204">
              No es trabajar más.
            </p>
            <p className="text-3xl font-black text-amber-600 mt-2" data-id="element-205">
              Es trabajar con sistema.
            </p>
          </div>

          <CTAButton text="🚀 QUIERO TRANSFORMAR MI ESTUDIO AHORA" data-id="element-206" />
        </div>
      </section>

      {/* SECTION 8 - BONUSES */}
      <section className="py-20 px-4 bg-gray-900 text-white" data-id="element-207">
        <div className="max-w-6xl mx-auto" data-id="element-208">
          <div className="text-center mb-12" data-id="element-209">
            <h2 className="text-4xl md:text-5xl font-black mb-4 text-amber-400" data-id="element-210">
              🎁 Regalos especiales
            </h2>
            
            <div className="inline-block bg-red-600 text-white font-black px-6 py-2 rounded-lg text-xl animate-pulse" data-id="element-211">
              Estos bonos son GRATIS por el día de hoy
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-212">
            {/* Bono 1 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col" data-id="element-213">
              <a href="#compra" className="block overflow-hidden bg-gray-100" data-id="element-214">
                <img src="https://cdn.magicpatterns.com/uploads/xr2aUhBZfS2j2J3hV3pN3A/ChatGPT_Image_2_mar_2026,_23_04_36.png" alt="Bono 1" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-215" />
              </a>
              <div className="p-6 flex-1 flex flex-col" data-id="element-216">
                <h4 className="text-xl font-black text-amber-600 mb-4" data-id="element-217">
                  🎁 BONO #1 – Kit Premium de Evaluaciones
                </h4>
                <ul className="space-y-3 font-medium flex-1" data-id="element-218">
                  <li className="flex items-start gap-2" data-id="element-219">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-220" />{' '}
                    Plantillas listas
                  </li>
                  <li className="flex items-start gap-2" data-id="element-221">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-222" />{' '}
                    Modelo tipo TEST
                  </li>
                  <li className="flex items-start gap-2" data-id="element-223">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-224" />{' '}
                    Sistema práctico de control
                  </li>
                </ul>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col" data-id="element-225">
              <a href="#compra" className="block overflow-hidden bg-gray-100" data-id="element-226">
                <img src="https://cdn.magicpatterns.com/uploads/jX9cW2gRSVcWRgzBkLMm8r/ChatGPT_Image_2_mar_2026,_23_04_41.png" alt="Bono 2" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-227" />
              </a>
              <div className="p-6 flex-1 flex flex-col" data-id="element-228">
                <h4 className="text-xl font-black text-amber-600 mb-4" data-id="element-229">
                  🎁 BONO #2 – Kit Estudio Bajo Control
                </h4>
                <ul className="space-y-3 font-medium flex-1" data-id="element-230">
                  <li className="flex items-start gap-2" data-id="element-231">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-232" />{' '}
                    Tablero visual de vencimientos
                  </li>
                  <li className="flex items-start gap-2" data-id="element-233">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-234" />{' '}
                    Sistema anti-urgencias
                  </li>
                  <li className="flex items-start gap-2" data-id="element-235">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-236" />{' '}
                    Organización mensual clara
                  </li>
                </ul>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col" data-id="element-237">
              <a href="#compra" className="block overflow-hidden bg-gray-100" data-id="element-238">
                <img src="https://cdn.magicpatterns.com/uploads/t1xqQxxge7kv2h529ugb9K/ChatGPT_Image_2_mar_2026,_23_04_26.png" alt="Bono 3" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-239" />
              </a>
              <div className="p-6 flex-1 flex flex-col" data-id="element-240">
                <h4 className="text-xl font-black text-amber-600 mb-4" data-id="element-241">
                  🎁 BONO #3 – Manual de Seguridad y Uso Profesional Inteligente
                </h4>
                <ul className="space-y-3 font-medium flex-1" data-id="element-242">
                  <li className="flex items-start gap-2" data-id="element-243">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-244" />{' '}
                    Buenas prácticas
                  </li>
                  <li className="flex items-start gap-2" data-id="element-245">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-246" />{' '}
                    Protección de información
                  </li>
                  <li className="flex items-start gap-2" data-id="element-247">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-248" />{' '}
                    Uso responsable
                  </li>
                  <li className="flex items-start gap-2" data-id="element-249">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-250" />{' '}
                    Protocolo profesional
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 9 - TESTIMONIALS */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-251">
        <div className="max-w-6xl mx-auto" data-id="element-252">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-253">
            Lo que dicen otros profesionales...
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-254">
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-255">
              <div className="flex items-center gap-4 mb-4" data-id="element-256">
                <img src="https://i.pravatar.cc/80?img=5" alt="María González" className="w-14 h-14 rounded-full" data-id="element-257" />
                <div data-id="element-258">
                  <h4 className="font-bold text-gray-900" data-id="element-259">María González</h4>
                  <p className="text-sm text-gray-500" data-id="element-260">
                    Contadora - Buenos Aires
                  </p>
                </div>
              </div>
              <div className="flex text-amber-400 mb-2" data-id="element-261">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-262">
                "Antes vivía corriendo detrás de los vencimientos. Con el Mega
                Pack logré estructurar mi estudio y recuperé al menos 2 horas
                diarias que antes perdía en desorden. Increíble."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-263">
              <div className="flex items-center gap-4 mb-4" data-id="element-264">
                <img src="https://i.pravatar.cc/80?img=11" alt="Carlos Fernández" className="w-14 h-14 rounded-full" data-id="element-265" />
                <div data-id="element-266">
                  <h4 className="font-bold text-gray-900" data-id="element-267">Carlos Fernández</h4>
                  <p className="text-sm text-gray-500" data-id="element-268">
                    Contador Público - Córdoba
                  </p>
                </div>
              </div>
              <div className="flex text-amber-400 mb-2" data-id="element-269">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-270">
                "El modo urgencia era mi día a día. Implementar los 5 tomos me
                dio la claridad que necesitaba. Ya no apago incendios, ahora
                gestiono mi estudio como una verdadera empresa."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-271">
              <div className="flex items-center gap-4 mb-4" data-id="element-272">
                <img src="https://i.pravatar.cc/80?img=9" alt="Laura Martínez" className="w-14 h-14 rounded-full" data-id="element-273" />
                <div data-id="element-274">
                  <h4 className="font-bold text-gray-900" data-id="element-275">Laura Martínez</h4>
                  <p className="text-sm text-gray-500" data-id="element-276">
                    Estudio Contable - Rosario
                  </p>
                </div>
              </div>
              <div className="flex text-amber-400 mb-2" data-id="element-277">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-278">
                "El Tomo 2 de comunicación me salvó la vida. Las plantillas y
                respuestas estructuradas elevaron mi autoridad frente a los
                clientes. Ya no me preguntan lo mismo mil veces."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 lg:col-start-1 lg:col-end-2 lg:ml-auto lg:w-full" data-id="element-279">
              <div className="flex items-center gap-4 mb-4" data-id="element-280">
                <img src="https://i.pravatar.cc/80?img=12" alt="Roberto Sánchez" className="w-14 h-14 rounded-full" data-id="element-281" />
                <div data-id="element-282">
                  <h4 className="font-bold text-gray-900" data-id="element-283">Roberto Sánchez</h4>
                  <p className="text-sm text-gray-500" data-id="element-284">
                    Contador Independiente - Mendoza
                  </p>
                </div>
              </div>
              <div className="flex text-amber-400 mb-2" data-id="element-285">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-286">
                "El plan de 30 días es oro puro. No es teoría, es pura práctica.
                Seguí el paso a paso y el cambio en la organización de mi
                trabajo fue radical."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 lg:col-start-2 lg:col-end-3" data-id="element-287">
              <div className="flex items-center gap-4 mb-4" data-id="element-288">
                <img src="https://i.pravatar.cc/80?img=1" alt="Ana Rodríguez" className="w-14 h-14 rounded-full" data-id="element-289" />
                <div data-id="element-290">
                  <h4 className="font-bold text-gray-900" data-id="element-291">Ana Rodríguez</h4>
                  <p className="text-sm text-gray-500" data-id="element-292">Contadora - La Plata</p>
                </div>
              </div>
              <div className="flex text-amber-400 mb-2" data-id="element-293">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-294">
                "Por primera vez en años siento que tengo el control de mi
                estudio y no al revés. La inversión se paga sola con el tiempo
                que ahorrás en el primer mes."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 10 - PURCHASE SECTION */}
      <section id="compra" className="py-20 px-4 bg-white border-t border-gray-200" data-id="element-295">
        <div className="max-w-4xl mx-auto bg-amber-50 rounded-3xl p-8 md:p-12 border-4 border-amber-400 shadow-2xl relative" data-id="element-296">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-2 rounded-full font-black text-lg md:text-xl shadow-lg whitespace-nowrap" data-id="element-297">
            ⏰ Acceso disponible por tiempo limitado
          </div>

          <div className="mt-8 mb-10" data-id="element-298">
            <h3 className="text-2xl font-bold text-center mb-6" data-id="element-299">Incluye:</h3>
            <ul className="space-y-4 text-lg md:text-xl font-bold text-gray-800 max-w-lg mx-auto" data-id="element-300">
              <li className="flex items-center gap-3" data-id="element-301">
                <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0" data-id="element-302" />{' '}
                5 Tomos completos
              </li>
              <li className="flex items-center gap-3" data-id="element-303">
                <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0" data-id="element-304" />{' '}
                3 Bonos profesionales
              </li>
              <li className="flex items-center gap-3" data-id="element-305">
                <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0" data-id="element-306" />{' '}
                Sistema integral estructurado
              </li>
              <li className="flex items-center gap-3" data-id="element-307">
                <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0" data-id="element-308" />{' '}
                Acceso digital inmediato
              </li>
              <li className="flex items-center gap-3" data-id="element-309">
                <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0" data-id="element-310" />{' '}
                Implementación en 30 días
              </li>
            </ul>
          </div>

          <div className="bg-white p-6 rounded-xl border border-gray-200 mb-10 text-center" data-id="element-311">
            <div className="flex justify-center mb-4" data-id="element-312">
              <ShieldCheck className="w-16 h-16 text-green-500" data-id="element-313" />
            </div>
            <h4 className="text-2xl font-black mb-2 flex items-center justify-center gap-2" data-id="element-314">
              <Lock className="w-6 h-6" data-id="element-315" /> Garantía sin riesgo
            </h4>
            <p className="text-gray-700 font-medium mb-4" data-id="element-316">
              Implementalo durante los primeros días.
            </p>
            <p className="text-gray-700 font-medium mb-4" data-id="element-317">
              Si no sentís mayor claridad y estructura, podés solicitar
              reembolso.
            </p>
            <p className="text-gray-900 font-bold" data-id="element-318">
              Porque el problema no es tu capacidad. Es la falta de sistema.
            </p>
            <p className="text-amber-600 font-bold mt-2" data-id="element-319">
              Y eso es exactamente lo que resuelve este Mega Pack.
            </p>
          </div>

          <CTAButton text="👉 SÍ, QUIERO MI MEGA PACK AHORA" href={PURCHASE_LINK} isExternal={true} className="text-2xl md:text-3xl py-6" data-id="element-320" />
          <div className="text-center mt-4 text-sm text-gray-500 font-medium flex items-center justify-center gap-1" data-id="element-321">
            <Lock className="w-4 h-4" data-id="element-322" /> Pago 100% Seguro
          </div>
        </div>
      </section>

      {/* SECTION 11 - WHO IS THIS FOR */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-323">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-324">
          <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-green-500" data-id="element-325">
            <h3 className="text-2xl font-black mb-6 text-gray-900" data-id="element-326">
              💼 ¿Para quién es?
            </h3>
            <ul className="space-y-4 font-medium text-lg" data-id="element-327">
              <li className="flex items-start gap-3" data-id="element-328">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-329" />{' '}
                Contadores independientes
              </li>
              <li className="flex items-start gap-3" data-id="element-330">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-331" />{' '}
                Estudios contables
              </li>
              <li className="flex items-start gap-3" data-id="element-332">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-333" />{' '}
                Áreas contables empresariales
              </li>
              <li className="flex items-start gap-3" data-id="element-334">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-335" />{' '}
                Profesionales que quieren modernizar su operación
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-red-500" data-id="element-336">
            <h3 className="text-2xl font-black mb-6 text-gray-900" data-id="element-337">
              🚫 ¿Para quién NO es?
            </h3>
            <ul className="space-y-4 font-medium text-lg" data-id="element-338">
              <li className="flex items-start gap-3" data-id="element-339">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-340" />{' '}
                Para quien quiere seguir improvisando
              </li>
              <li className="flex items-start gap-3" data-id="element-341">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-342" />{' '}
                Para quien no está dispuesto a ordenar procesos
              </li>
              <li className="flex items-start gap-3" data-id="element-343">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-344" />{' '}
                Para quien busca soluciones mágicas sin aplicar
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* SECTION 12 - WHAT YOU'RE REALLY BUYING */}
      <section className="py-20 px-4 bg-black text-white text-center" data-id="element-345">
        <div className="max-w-4xl mx-auto" data-id="element-346">
          <h2 className="text-4xl md:text-5xl font-black mb-8 text-amber-500" data-id="element-347">
            📈 Lo que realmente estás comprando
          </h2>
          <p className="text-2xl font-bold mb-10 text-gray-300" data-id="element-348">
            No son 5 ebooks.
          </p>
          <p className="text-xl mb-8" data-id="element-349">Estás comprando:</p>

          <ul className="text-2xl md:text-3xl font-black space-y-6 text-amber-400" data-id="element-350">
            <li data-id="element-351">Un estándar profesional nuevo.</li>
            <li data-id="element-352">Un sistema replicable.</li>
            <li data-id="element-353">Una estructura que reduce estrés y recupera tiempo.</li>
            <li data-id="element-354">Una forma distinta de operar.</li>
          </ul>
        </div>
      </section>

      {/* SECTION 13 - FINAL CTA */}
      <section className="py-24 px-4 bg-white text-center" data-id="element-355">
        <div className="max-w-4xl mx-auto" data-id="element-356">
          <h2 className="text-5xl md:text-6xl font-black mb-6 text-center" data-id="element-357">
            <span className="block" data-id="element-358">🏆 MEGA PACK</span>
            <span className="block text-amber-500" data-id="element-359">CONTADOR ÉLITE</span>
          </h2>
          <p className="text-2xl md:text-3xl font-bold text-gray-600 mb-12" data-id="element-360">
            El sistema inteligente para optimizar tu estudio, recuperar tiempo y
            trabajar con verdadera tranquilidad profesional.
          </p>

          <div className="text-3xl md:text-4xl font-black text-amber-600 space-y-4 mb-12" data-id="element-361">
            <p data-id="element-362">👉 Es momento de dejar de correr.</p>
            <p data-id="element-363">👉 Es momento de trabajar como un verdadero Contador Élite.</p>
          </div>

          <CTAButton text="🚀 SÍ, QUIERO ACCEDER AL SISTEMA AHORA" href={PURCHASE_LINK} isExternal={true} className="text-2xl md:text-3xl py-6" data-id="element-364" />
        </div>
      </section>
    </div>;
}